import { FEATURE_NAME } from 'src/redesign/features/AttendeeEventsSidebar/store/constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as T from 'src/redesign/features/AttendeeEventsSidebar/store/types';
import type { AttendeeTicket } from 'src/types/types';

const initialState: T.AttendeeEventsSidebarState = {
  show: false,
  currentEvent: null,
};

export const attendeeEventsSidebarSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    showAttendeeEventsSidebar: (state) => {
      state.show = !!state.currentEvent;
    },
    hideAttendeeEventsSidebar: (state) => {
      state.show = false;
    },
    setCurrentEvent: (state, action: PayloadAction<AttendeeTicket>) => {
      state.currentEvent = action.payload;
    },
  },
});

export const attendeeEventsSidebarActions = attendeeEventsSidebarSlice.actions;
